import { developmentPlanConstants } from '../../_constants';
import { developmentPlanService } from '../../_services';
import { developmentPlanActions } from './getDevelopmentPlan.action';

export const updateRelationList = {
    updateRelationListHandler
};

function updateRelationListHandler(data,id) {
    return dispatch => {
        dispatch(request());
        developmentPlanService.updateRelationListHandler(data,id)
            .then(
                updateRelationListData => {
                    dispatch(developmentPlanActions.getDevelopmentPlan())
                    dispatch(success(updateRelationListData));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: developmentPlanConstants.REQUEST_UPDATE_RELATIONLIST} }
    function success(updateRelationListData) { return { type: developmentPlanConstants.RECEIVE_UPDATE_RELATIONLIST, updateRelationListData } }
    function failure(error) { return { type: developmentPlanConstants.UPDATE_RELATIONLIST_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/DevelopmentPlan/updateRelationList.action.js